import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cm6t2hxqzv: FaireBrandEntity = {
  token: "b_cm6t2hxqzv",
  type: "brand",
  name: "By Orly",
  avatarUrl:
    "https://cdn.faire.com/fastly/3d6844bea6d0e239701e63509eeacf2948ed8769ec55930a5b754ce53ec35c1d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4661b2db0388c6b32bd25479e368f81283da50c6bb365489e8180e94608d7e8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3d6844bea6d0e239701e63509eeacf2948ed8769ec55930a5b754ce53ec35c1d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4661b2db0388c6b32bd25479e368f81283da50c6bb365489e8180e94608d7e8.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "BY ORLY effortlessly blends classic style with a touch of uniqueness, sourcing only the finest materials to create each handcrafted piece. From bold and fun to minimalist and sleek, these accessories are designed to stand out on any occasion.\n\nOrly, the creative force behind the brand, discovered her love for jewelry-making early on. With over 15 years of professional experience in the industry, she's turned her passion into a brand that reflects her classic yet eclectic personal style.\n\nBased in Los Angeles, every BY ORLY piece is made with love by Orly herself. Whether you're into vibrant colors or a more laid-back look, our accessories are the perfect addition to your everyday style.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:10.201Z",
    importedBy: "entity-db-cli",
  },
};
